export const projects = [
  {
    id: 'quizmatch',
    title: 'QuizMatch',
    description: 'Eğlenceli bir quiz uygulaması',
    fullDescription: 'Multiplayer quiz app with real-time scoring',
    details: [
      'Developed by Flutter',
      'Node.js integration',
      'MySQL integration'
    ],
    video: 'https://www.atabekhsa.com/videos/quizmatch.mp4',
    technologies: ['Flutter'],
    link: 'https://play.google.com/store/apps/details?id=com.atabekhsa.quizmatch'
  },
  {
    id: 'menum_yanimda',
    title: 'Menum Yanımda',
    description: 'Menum Yanımda',
    fullDescription: 'Menum Yanımda',
    details: [
      'Developed by Flutter',
      'Php integration',
      'MySQL integration'
    ],
    video: 'https://www.atabekhsa.com/videos/m_yanimda.mp4',
    technologies: ['Flutter', 'PHP', 'MySQL'],
    link: 'https://atabekhsa.com'
  }
];
